import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { PRICE_SCHEDULE_MODES } from "../../common_nextgen/utils/Constants";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import { ROUTE_PATHS, NO_CHANGE_OF_INFO } from "../../common_nextgen/utils/Constants";
import useLookupNavigation from "../../common_nextgen/common_components/common-hooks/useLookupNavigation";

const PatientPayTableAdditionalScheduleForm = ({ mode }) => {
  const { axios_helper_no_header } = useAxios();
  const location = useLocation();

  const stateVal = location.state;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  const {
    selectedSchedules = [],
    previousScreen = ROUTE_PATHS.COPAY_SCHEDULE_STEPS,
    currentIndex: initialIndex = 0,
    submittedData,
    paramsData,
    lookupMode: initialLookupMode = false,
    lookupScreen,
    lookupParams,
    formData: baseFormData = {},
    navigateData,
  } = currentState;

  const navigateToPage = useCustomNavigate();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState(baseFormData);
  const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();

  /* const { showModal } = useModal();
  const [lookupData, setLookupData] = useState({});
  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
    showModal(lookupScreen, { params }, handleReceiveData, formData);
  };

   const viewLookupDetails = (lookupScreen, params, formData) => {
    console.log(params,"params")
      const { viewType, fieldMapping } = params;
      const { default: screenNumber } = lookupScreen;
      if (viewType === "legacy") {
        const { default: viewParams } = fieldMapping;
        const paramData = viewParams.reduce((acc, item) => {
          const resolver = item["resolver"]
            ? LegacyResolvers[item["resolver"]]
            : null;
            if(item["legacy"] !==undefined){
              acc[item["legacy"]] = resolver
                ? resolver(formData[item["source"]])
                : formData[item["source"]];
            }
          return acc;
        }, {});
        const message = {
          message: "navigate-to-presto",
          programCode: LEGACY_SCREEN_VIEW[screenNumber],
          parameters: paramData,
        };
        console.log("message", message);
        window.top?.postMessage(message, "*");
      } else {
        showModal(lookupScreen, { params }, null, formData, true);
      }
    };
  */

  const {
    lookupData,
    fetchLookupData,
    viewLookupDetails,
    lookupMode,
    setLookupMode,
  } = useLookupNavigation({
    initialLookupMode,
    lookupParams,
    initialIndex,
    previousState,
    currentState,
    lookupScreen,
    navigateData,
    initialFormData,
  });

  const handleBack = () => {
    if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setLookupMode(false);
      setCurrentMode(mode);
    } else {
      /*  const lastScheduleName = selectedSchedules[currentIndex]?.ps4PtPaySchTableName || "";
      const updatedParamsData = {
        ...currentState.paramsData,
        ps4PtPaySchTableName: lastScheduleName,
      };
      navigateToPage(previousScreen, [
        ...previousState,
        {
          ...currentState,
          paramsData: updatedParamsData,
          currentIndex,
        },
      ]);  */
      navigateToPage(previousScreen, previousState);
    }
  };

  const getPageTitle = useCallback(() => {
    const [screenTitle, screenNumber] = isAddMode(currentMode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>-</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  }, [currentMode]);

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";
    let infoChanged = true;

    if (isAddMode(currentMode)) {
      url = "api/appaddlpatientpay";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/appaddlpatientpay";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];
    }

    if (JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)) {
         infoChanged = false;
    }

    const data = { ...dataForSubmission, screenNumber, infoChanged };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
       if (responseStatus.message === NO_CHANGE_OF_INFO) {
                                                toast.current.show({
                                                  severity: "info",
                                                  summary: "",
                                                  detail: responseStatus.message,
                                                  life: 3000,
                                                });
                                              } else {
                                                toast.current.show({
                                                  severity: "success",
                                                  summary: "",
                                                  detail: responseStatus.message,
                                                  life: 3000,
                                                }); 
      setInitialFormData(responseData);
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        navigateToPage(ROUTE_PATHS.EDIT_PATIENTPAY_TABLE_ADDIITIONAL_SCHEDULE, [
          ...previousState,
          {
            selectedSchedules: [responseData],
            previousScreen: previousScreen,
            currentIndex: 0,
            lookupMode: false,
          },
        ]);
      }
    }} catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
      keyName.chmod = "View";
      keyFunc.F11 = () => {
        openConfirmationModal();
      };
      keyName.F11 = "Delete";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
      keyFunc.F11 = () => {
        openConfirmationModal();
      };
      keyName.F11 = "Delete";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex]);

  useEffect(() => {
    const fetchInitialData = async () => {
      var scheduleName;
      if (submittedData?.ps4PtPaySchTableName) {
        scheduleName = submittedData?.ps4PtPaySchTableName;
      } else {
        scheduleName = selectedSchedules?.[currentIndex]?.ps4PtPaySchTableName;
      }

      const url = isAddMode(currentMode)
        ? `api/appaddlpatientpay/initial-form-data/${encodeURIComponent(
            scheduleName
          )}`
        : `api/appaddlpatientpay/${encodeURIComponent(scheduleName)}`;
      try {
        const { responseData } = await axios_helper_no_header("GET", url);
        setInitialFormData(responseData);
      } catch (e) {
        console.log(e);
      }
    };
    if (!Object.keys(baseFormData).length) fetchInitialData();
  }, [mode, currentIndex, currentMode]);

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    console.log(selectedOption);
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteAdditionalPatientSchedule = () => {
    if (selectedOption === "yes") {
      axios_helper_no_header(
        "DELETE",
        `api/appaddlpatientpay/${encodeURIComponent(
          selectedSchedules[currentIndex].ps4PtPaySchTableName
        )}`,
        null,
        null
      )
        .then((response) => {
          if (response?.responseStatus?.statusCode === "SUCCESS") {
            closeConfirmationModal();
            // navigateToPage(ROUTE_PATHS.PATIENT_PAY_TABLE);
            handleBack();
          } else {
            toast.current.show({
              severity: "error",
              summary: "",
              detail: response.responseStatus.message,
              life: 3000,
            });
            closeConfirmationModal();
          }
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          lookupData={lookupData}
          fetchLookupData={fetchLookupData}
          viewLookupDetails={viewLookupDetails}
        />
        {isConfirmationModalOpen && (
          <ConfirmationModal
            isOpen={isConfirmationModalOpen}
            onRequestClose={closeConfirmationModal}
            onBack={closeConfirmationModal}
            onSave={deleteAdditionalPatientSchedule}
            confirmLabel="Confirm(Y/N)"
            options={[
              { label: "N-No", value: "no" },
              { label: "Y-Yes", value: "yes" },
            ]}
            setSelectedOption={setSelectedOption}
          />
        )}
      </div>
    </div>
  );
};

export default PatientPayTableAdditionalScheduleForm;

const formFields = [
  {
    section: "Section 1",
    name: "ps4PtPaySchTableName",
    label: "Table",
    fieldLabel: "PS4 Pt Pay Sch Table Name",
    type: "text",
    options: {
      required: { value: true, message: "Value required" },
      maxLength: {
        value: 13,
        message: "Cannot exceed more than 13 characters",
      },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [3, 10],
  },
  {
    section: "Section 1",
    name: "ps4PatPayDescription",
    label: "Description",
    fieldLabel: "PS4 Pat Pay Description",
    type: "text",
    options: {
      required: { value: true, message: "Value required" },
      maxLength: {
        value: 25,
        message: "Cannot exceed more than 25 characters",
      },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [4, 10],
  },
  {
    section: "Brand(Header)",
    name: "apsAddtlPatPaySch",
    label: "Additional Patient Pay 1 Sched and Step",
    fieldLabel: "APS Addtl Pat Pay Sch",
    type: "lookup",
    viewType: "local",
    externalProgram: { default: "RCAPS004" },
    params: {
      lookupType: "local",
      viewType: "local",
      disabledDropdown: true,
      fieldMapping: {
        default: [
          {
            source: "apsAddtlPatPaySch",
            target: "apsAddtlPatPaySch",
            legacy: "apsAddtlPatPaySch",
          },
          {
            source: "aptStepsNbr",
            target: "aptStepsNbr",
          },
          {
            source: "apsAddtlPatPaySchDesc",
            target: "apsAddtlPatpaySchDesc",
            legacy: "apsAddtlPatpaySchDesc",
          },
        ],
      },
    },
    options: {
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 10],
  },
  {
    section: "Brand(Header)",
    name: "aptStepsNbr",
    label: "",
    fieldLabel: "APT Steps Nbr",
    type: "lookup",
    viewType: "local",
    type: "lookup",
    inputType: "number",
    viewMode: "text",
    externalProgram: { default: "RCAPT004" },
    params: {
      lookupType: "local",
      fieldMapping: {
        default: [
          {
            source: "apsAddtlPatPaySch",
            target: "apsAddtlPatPaySch",
          },
          {
            source: "aptStepsNbr",
            target: "aptStepsNbr",
          },
        ],
      },
    },
    options: {
      min: { value: 0, message: "Minimum value is 0" },
      max: { value: 99, message: "Maximum value is 99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 12],
  },
  {
    section: "Brand(Header)",
    name: "apsAddtlPatPaySch2",
    label: "Additional Patient Pay 2 Sched and Step",
    fieldLabel: "APS Addtl Pat Pay Sch 2",
    type: "lookup",
    viewType: "local",
    externalProgram: { default: "RCAPS004" },
    params: {
      lookupType: "local",
      viewType: "local",
      disabledDropdown: true,
      fieldMapping: {
        default: [
          {
            source: "apsAddtlPatPaySch2",
            target: "apsAddtlPatPaySch",
            legacy: "apsAddtlPatPaySch",
          },
          {
            source: "aptStepsNbr2",
            target: "aptStepsNbr",
          },
          {
            source: "apsAddtlPatPaySch2Desc",
            target: "apsAddtlPatPaySchDesc",
            legacy: "apsAddtlPatPaySchDesc",
          },
        ],
      },
    },
    options: {
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 10],
  },
  {
    section: "Brand(Header)",
    name: "aptStepsNbr2",
    label: "",
    fieldLabel: "APT Steps Nbr 2",
    type: "lookup",
    viewType: "local",
    viewMode: "text",
    type: "lookup",
    inputType: "number",
    externalProgram: { default: "RCAPT004" },
    params: {
      lookupType: "local",
      viewType: "local",
      fieldMapping: {
        default: [
          {
            source: "apsAddtlPatPaySch2",
            target: "apsAddtlPatPaySch",
          },
          {
            source: "aptStepsNbr2",
            target: "aptStepsNbr",
          },
        ],
      },
    },
    options: {
      min: { value: 0, message: "Minimum value is 0" },
      max: { value: 99, message: "Maximum value is 99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 12],
  },
  {
    section: "Generic(Header)",
    name: "apsAddtlPatPaySchGenr1",
    label: "Additional Patient Pay 1 Sched and Step",
    fieldLabel: "APS Addtl PatPaySch Genr1",
    type: "lookup",
    externalProgram: { default: "RCAPS004" },
    params: {
      lookupType: "local",
      viewType: "local",
      disabledDropdown: true,
      fieldMapping: {
        default: [
          {
            source: "apsAddtlPatPaySchGenr1",
            target: "apsAddtlPatPaySch",
            legacy: "apsAddtlPatPaySch",
          },
          {
            source: "aptStepsNbrGenr1",
            target: "aptStepsNbr",
          },
          {
            source: "apsAddtlPatPaySchGenr1Desc",
            target: "apsAddtlPatPaySchDesc",
            legacy: "apsAddtlPatPaySchDesc",
          },
        ],
      },
    },
    options: {
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [11, 10],
  },
  {
    section: "Generic(Header)",
    name: "aptStepsNbrGenr1",
    label: "",
    fieldLabel: "APT Steps Nbr Genr1",
    type: "lookup",
    externalProgram: { default: "RCAPT004" },
    inputType: "number",
    viewMode: "text",
    params: {
      lookupType: "local",
      viewType: "local",
      fieldMapping: {
        default: [
          {
            source: "apsAddtlPatPaySchGenr1",
            target: "apsAddtlPatPaySch",
          },
          {
            source: "aptStepsNbrGenr1",
            target: "aptStepsNbr",
          },
        ],
      },
    },
    options: {
      min: { value: 0, message: "Minimum value is 0" },
      max: { value: 99, message: "Maximum value is 99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [11, 12],
  },
  {
    section: "Generic(Header)",
    name: "apsAddtlPatPaySchGenr2",
    label: "Additional Patient Pay 2 Sched and Step",
    fieldLabel: "APS Addtl PatPaySch Genr2",
    type: "lookup",
    externalProgram: { default: "RCAPS004" },
    params: {
      lookupType: "local",
      viewType: "local",
      disabledDropdown: true,
      fieldMapping: {
        default: [
          {
            source: "apsAddtlPatPaySchGenr2",
            target: "apsAddtlPatPaySch",
            legacy: "apsAddtlPatPaySch",
          },
          {
            source: "aptStepsNbrGenr2",
            target: "aptStepsNbr",
          },
          {
            source: "apsAddtlPatPaySchGenr2Desc",
            target: "apsAddtlPatPaySchDesc",
            legacy: "apsAddtlPatPaySchDesc",
          },
        ],
      },
    },
    options: {
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [12, 10],
  },
  {
    section: "Generic(Header)",
    name: "aptStepsNbrGenr2",
    label: "",
    fieldLabel: "APT Steps Nbr Genr2",
    type: "lookup",
    inputType: "number",
    viewMode: "text",
    externalProgram: { default: "RCAPT004" },
    params: {
      lookupType: "local",
      viewType: "local",
      fieldMapping: {
        default: [
          {
            source: "apsAddtlPatPaySchGenr2",
            target: "apsAddtlPatPaySch",
          },
          {
            source: "aptStepsNbrGenr2",
            target: "aptStepsNbr",
          },
        ],
      },
    },
    options: {
      min: { value: 0, message: "Minimum value is 0" },
      max: { value: 99, message: "Maximum value is 99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [12, 12],
  },
  {
    section: "Section 3",
    name: "appAdditionalPatPayQl",
    label: "Additional Patient Pay Qualifier",
    fieldLabel: "APP Additional Pat Pay Ql",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {
      maxLength: { value: 1, message: "Cannot exceed more than 1 characters" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [15, 10],
  },
  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 14],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 32],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: {
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 52],
  },
];

const screenInfo = {
  ADD: ["Add Patient Pay Table Additional Patient Pay Schedule", "RCAPP002"],
  CHANGE: ["Patient Pay Table Additional Patient Pay Schedule", "RCAPP001"],
};
